import { Component, Input } from '@angular/core';
import { DxChartModule } from 'devextreme-angular/ui/chart';
import { CardAnalyticsComponent } from '../card-analytics/card-analytics.component';

@Component({
  selector: 'dk-revenue-card',
  templateUrl: './revenue-card.component.html',
  standalone: true,
  imports: [CardAnalyticsComponent, DxChartModule],
})
export class RevenueCardComponent {
  @Input() data: any;
}
